import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        competence: '<'
    },
    template: `
            <div class="heading01 type01">
                <h1>{{ vm.competence.name }}</h1>
                <a class="btn edit" ng-click="vm.editCompetence(vm.competence)">{{ 'user.Edit general data' | translate }}</a>
            </div>
            <div class="well">
                <div class="heading01">
                    <h2>{{ 'user.Skills' | translate }}</h2>
                    <a class="btn add" ng-click="vm.addSkill(vm.competence)">{{ 'user.Add skill' | translate }}</a>
                </div>
                <list-factory-empty list="vm.skillList" show-add-message="true"></list-factory-empty>
                <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.skillList.items.length">
                    <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'user.Name' | translate }}</a></th>
                        <th>{{ 'user.Competency skill type' | translate }}</th>
                        <th class="actions nosort">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="competencySkill in vm.skillList.items">
                            <td>{{ competencySkill.skill.name }}</td>
                            <td>{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS[competencySkill.type] }}</td>
                            <td class="actions">
                                <a ng-click="vm.editSkill(competencySkill)" class="btn edit">{{ 'general.Edit' | translate }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination list="vm.skillList"></pagination>
            </div>
            <ul class="actions01">
                <li class="primary"><button class="btn negative" ng-click="vm.deleteCompetence()">{{ 'user.Delete competence' | translate }}</button></li>
                <li><a class="btn discrete">{{ 'general.Back' | translate }}</a></li>
            </ul>
    `
})
export default class {
    constructor ($translate, $state, ListFactory, SkillResource, CompetenceResource, ModalService, DATATABLES, USER_COMPETENCE_SKILL_TYPE_ENUM) {
        this.$translate = $translate;
        this.$state = $state;
        this.SkillResource = SkillResource;
        this.CompetenceResource = CompetenceResource;
        this.ModalService = ModalService;
        this.ListFactory = ListFactory;
        this.DATATABLES = DATATABLES;
        this.USER_COMPETENCE_SKILL_TYPE_ENUM = USER_COMPETENCE_SKILL_TYPE_ENUM;
    }

    $onInit () {
        this.skillList = this.ListFactory.createWithPagination(this.SkillResource.competenceSkills.bind(this.SkillResource));
        this.fetchSkills();
    }

    fetchSkills () {
        this.skillList.fetch({ competenceId: this.competence.id, expand: 'skill' });
    }

    editCompetence (competence) {
        return this.ModalService.open({
            template: `<modals-competence-competence-edit competence="vm.competence" on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update(updatedCompetence)" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.competence = competence;
                this.update = (updatedCompetence) => {
                    this.$uibModalInstance.close(updatedCompetence);
                };
            }
        }).then((updatedCompetence) => {
            this.competence = updatedCompetence;
        });
    }

    addSkill (competence) {
        return this.ModalService.open({
            template: `<modals-competence-competence-add-skill competence="vm.competence" on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update(updatedCompetence)" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.competence = competence;
                this.update = (updatedCompetence) => {
                    this.$uibModalInstance.close(updatedCompetence);
                };
            }
        }).then(() => {
            this.fetchSkills();
        });
    }

    editSkill (competenceSkill) {
        return this.ModalService.open({
            template: `<modals-competence-competence-edit-skill competence-skill="vm.competenceSkill" on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update(updatedCompetenceSkill)" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.competenceSkill = competenceSkill;
                this.update = (updatedCompetenceSkill) => {
                    this.$uibModalInstance.close(updatedCompetenceSkill);
                };
            }
        }).then(() => {
            this.fetchSkills();
        });
    }

    deleteCompetence () {
        const deleteMessage = this.$translate.instant('Do you want to delete competence?');
        this.ModalService.confirm(deleteMessage, 'medium')
            .then(() =>
                this.CompetenceResource.delete({ id: this.competence.id }).$promise
                    .then(() => this.$state.go('authorized.user.competence.competence.list'))
            )
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/competence/view/index.js